module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-code-fill-03425581.svg";